const TagModel = Backbone.Model.extend({
  initialize() {
    this.set('tagDesc', this.get('TagDesc'));
  },
  defaults: {
    'errorMessage': '',
    'createDate': '',
    'modifyDate': '',
    'TagDesc': '',
    'tagDesc': '',
    'tagVideoID': 0,
    'tagID': 0,
    'videoID': 0
  },
  url: $('body').data('domain') + '/api/Tags/Post'
});

export default TagModel;
